import Swiper, { Autoplay, Controller, EffectCreative, Navigation, Pagination } from "swiper";

document.addEventListener('DOMContentLoaded', () => {
  const traditionSlider = document.querySelector('.our-traditions__slider')

  if(traditionSlider) {
    const swiper = new Swiper(traditionSlider, {
      modules: [Navigation, EffectCreative, Autoplay, Controller, Pagination],
      effect: "creative",
      speed: 1000,
      parallax: true,
      loop: true,
      allowTouchMove: false,
      spaceBetween: 2,
      creativeEffect: {
        prev: {
          translate: ["-20%", 0, -1],
        },
        next: {
          translate: ["100%", 0, 0],
        },
      },
      pagination: {
        el: '.pagination',
        clickable: true,
        bulletClass: 'pagination__item our-traditions__pagination ',
        bulletActiveClass: 'pagination__item--active'
      },
      navigation: {
        prevEl: '.our-traditions__navigation .slider-navigation__button--prev',
        nextEl: '.our-traditions__navigation .slider-navigation__button--next'
      },
      breakpoints: {
        999: {
          loop: false,
          allowTouchMove: false
        },
        0: {
          loop: true,
          allowTouchMove: true
        }
      }
    });
    const paginations = traditionSlider.querySelectorAll('.our-traditions__pagination')

    document.querySelector('.pagination__item--active')?.classList.remove('pagination__item--active')


    let slideChange
    let throttle = false

    const startTimeout = () => {
      clearTimeout(slideChange)
      if (throttle) {
        slideChange = setTimeout(() => {
          throttle = false
          swiper.slideNext()
        }, 30000)
      } else {
        slideChange = setTimeout(() => {
          swiper.slideNext()
        }, 10000)
      }
    }

    const startAnimate = () => {
      swiper.autoplay.stop()
      throttle = true
    }

    swiper.on('slideChange', () => {
      startTimeout()
    })



    swiper.on('touchMove', () => throttle = true)

    document.querySelector('.our-traditions__navigation .slider-navigation__button--prev')?.addEventListener('click', startAnimate)
    document.querySelector('.our-traditions__navigation .slider-navigation__button--next')?.addEventListener('click', startAnimate)

    paginations.forEach(pagination => {
      pagination.addEventListener('click', startAnimate)
    })

    let animate = false

    window.addEventListener('scroll', () => {
      if(animate) return
      if (window.scrollY >= traditionSlider.offsetTop ) {
        animate = true
        paginations[0].classList.add('pagination__item--active')
        startTimeout()
      }
    })
  }
})